import React, { useEffect, useState } from 'react';
import Highcharts, { SeriesSplineOptions } from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { getFormattedValue, PeriodGroup, getPeriodTypeFromDuration, shouldPointBeBlue } from '../utils';

type MiniChartProps = {
	history?: { values: number[]; segmentsStats?: unknown[] };
	period: PeriodGroup;
	type: string;
	labels?: string[];
	historyDepth?: number;
};

const MiniChart = ({
	history,
	period,
	type,
	historyDepth,
	labels,
}: MiniChartProps) => {

	const recentAbsolutes = history?.values || [];

	const periodType = period && period.firstPeriode ? getPeriodTypeFromDuration(period.firstPeriode.start, period.firstPeriode.end) : 'Last7Days';
	if(!labels ) return null;

	const [chartOptions, setChartOptions] = useState({
		chart: {
			type: 'spline', 
			color: '#fff',
			height: 100 
		},
		title: {
			text: '',
		},
		xAxis: {
			categories: [] as string[],
			labels: {
				enabled: false
			},
			gridLineWidth: 0
		},
		yAxis: {
			title: { text: '' },
			labels: {
				enabled: false
			},
			gridLineWidth: 0
		},
		series: [
			{
				data: [] as Highcharts.PointOptionsObject[],
				type: 'spline',
				color: '#BFC0C9',
				marker: {
					enabled: false
				},
				states: {
					hover: {
						enabled: false
					}
				}
			} as Highcharts.SeriesSplineOptions
		],
		credits: {
			enabled: false
		},
		legend: {
			enabled: false
		},
		exporting: {
			enabled: false
		},
		tooltip: {
			enabled: true
		}
	});
	//const [customLegend, setCustomLegend] = useState<{ label: string, color: string }[]>([]);

	useEffect(() => {
		if (recentAbsolutes && recentAbsolutes.length > 1) {
		
			
			const points = recentAbsolutes.map((val, idx) => {
				let color = '#BFC0C9';
				
				if (idx === recentAbsolutes.length - 1) {
					const prev = recentAbsolutes[recentAbsolutes.length - 2];
					color = val > prev ? '#2ECC40' : '#FF4136';
				}
				else if (shouldPointBeBlue(idx, recentAbsolutes.length, historyDepth)) {
					color = '#5174ED'; 
				}
				
				return {
					y: Number(Number(val)),
					marker: {
						enabled: true,
						color: color,
					},
					color: color
				};
			});

			// const zones: Highcharts.SeriesZonesOptionsObject[] = [];
			// let inBlue = false;
			// for (let i = 0; i < recentAbsolutes.length; i++) {
			// 	const isBlue = (i < recentAbsolutes.length - 2) && shouldPointBeBlue(i, recentAbsolutes.length, historyDepth);
			// 	if (isBlue && !inBlue) {
			// 		zones.push({ value: i, color: '#BFC0C9' });
			// 		inBlue = true;
			// 	}
			// 	if (!isBlue && inBlue) {
			// 		zones.push({ value: i, color: '#5174ED' });
			// 		inBlue = false;
			// 	}
			// }
			// if (inBlue) {
			// 	zones.push({ value: recentAbsolutes.length, color: '#5174ED' });
			// }

			setChartOptions(prev => ({
				...prev,
				xAxis: {
					...prev.xAxis,
					categories: labels as string[]
				},
				series: [
					{
						data: points,
						type: 'spline',
						color: '#BFC0C9',
						pointWidth: 2,
						fillOpacity: 0.2,
						//zones: zones,
						zoneAxis: 'x',
						marker: {
							enabled: true,
							radius: 3,
						},
						states: {
							hover: {
								enabled: true
							}
						}
					} as SeriesSplineOptions
				],
				tooltip: {
					enabled: true,
					formatter: function(this: Highcharts.TooltipFormatterContextObject) {
						const idx = this.point.index;
						const date = labels[idx] || `Intervalle ${idx+1}`;
						return `<b>${date}</b><br/>Value: <b>${ getFormattedValue (this.y, null, type)}</b>`;
					}
				}
			}));

			// setCustomLegend([
			// 	{ label: 'Others', color: '#BFC0C9' },
			// 	{ label: labels[labels.length-2], color: '#5174ED' },
			// 	{ label: labels[labels.length-1], color: recentAbsolutes[recentAbsolutes.length-1] > recentAbsolutes[recentAbsolutes.length-2] ? '#2ECC40' : '#FF4136' }
			// ]);
		}
	}, [recentAbsolutes, period, periodType, historyDepth]);

	return (
		<div className=''>
			<HighchartsReact
				highcharts={Highcharts}
				options={chartOptions}
			/>
			{/* <div className="custom-legend" style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
				{[recentAbsolutes.length-2, recentAbsolutes.length-1].map((idx, i) => (
					<div key={i} style={{ margin: '0 10px', display: 'flex', alignItems: 'center' }}>
						<div style={{ width: '10px', height: '10px', backgroundColor: i === 0 ? '#5174ED' : (recentAbsolutes[recentAbsolutes.length-1] > recentAbsolutes[recentAbsolutes.length-2] ? '#2ECC40' : '#FF4136'), marginRight: '5px' }}></div>
						<span style={{ fontSize: '12px', color: '#333' }}>{labels[idx]}</span>
					</div>
				))}
			</div> */}
		</div>
	);
};


export default MiniChart;